import { Component, ojs, app } from "modular-openscriptjs";

const h = app("h");

export default class PaymentStatus extends Component {
	render(status, ...args) {
		const { cls, icon, text } = this.statusInfo(status);

		return h.span(
			{
				class: `badge rounded-pill ${cls} d-inline-flex align-items-center gap-1 px-3 py-2`,
			},
			h.i({ class: icon }),
			text || status
		);
	}

	statusInfo(status) {
		switch (status) {
			case "pending":
				return {
					cls: "bg-secondary",
					icon: "bi bi-clock",
					text: "Pending",
				};
			case "processing":
				return {
					cls: "bg-primary",
					icon: "bi bi-hourglass-split",
					text: "Processing",
				};
			case "completed":
			case "paid":
				return {
					cls: "bg-success",
					icon: "bi bi-check-circle-fill",
					text: "Paid",
				};
			case "failed":
				return {
					cls: "bg-danger",
					icon: "bi bi-exclamation-circle-fill",
					text: "Failed",
				};
			case "refunded":
				return {
					cls: "bg-warning text-dark",
					icon: "bi bi-arrow-return-left",
					text: "Refunded",
				};
			case "refund_pending":
				return {
					cls: "bg-primary",
					icon: "bi bi-arrow-counterclockwise",
					text: "Refund Pending",
				};
			default:
				return {
					cls: "bg-secondary",
					icon: "bi bi-question-circle",
					text: status,
				};
		}
	}
}
